/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../lib/schemas.js";
import { Result as SafeParseResult } from "../types/fp.js";
import { SDKValidationError } from "./errors/sdkvalidationerror.js";

export type CountLedgersResponse = {
  total: number;
};

/** @internal */
export const CountLedgersResponse$inboundSchema: z.ZodType<
  CountLedgersResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  total: z.number().int(),
});

/** @internal */
export type CountLedgersResponse$Outbound = {
  total: number;
};

/** @internal */
export const CountLedgersResponse$outboundSchema: z.ZodType<
  CountLedgersResponse$Outbound,
  z.ZodTypeDef,
  CountLedgersResponse
> = z.object({
  total: z.number().int(),
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace CountLedgersResponse$ {
  /** @deprecated use `CountLedgersResponse$inboundSchema` instead. */
  export const inboundSchema = CountLedgersResponse$inboundSchema;
  /** @deprecated use `CountLedgersResponse$outboundSchema` instead. */
  export const outboundSchema = CountLedgersResponse$outboundSchema;
  /** @deprecated use `CountLedgersResponse$Outbound` instead. */
  export type Outbound = CountLedgersResponse$Outbound;
}

export function countLedgersResponseToJSON(
  countLedgersResponse: CountLedgersResponse,
): string {
  return JSON.stringify(
    CountLedgersResponse$outboundSchema.parse(countLedgersResponse),
  );
}

export function countLedgersResponseFromJSON(
  jsonString: string,
): SafeParseResult<CountLedgersResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CountLedgersResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CountLedgersResponse' from JSON`,
  );
}
